import { createContext, useContext } from 'react'

import { useAuth } from '../../Shared/Contexts/AuthContext'

const OrganizationProfilesContext = createContext({})

export const useOrganizationProfiles = () => {
  return useContext(OrganizationProfilesContext)
}

export const OrganizationProfilesProvider = ({ children }) => {
  const { useBaseAxiosGet, useBaseAxiosPost, useBaseAxiosDelete, useBaseAxiosPut } = useAuth()

  const useFetchOrganizationProfiles = async ({ page, pageSize, fullText }) => {
    const params = new URLSearchParams()
    if (page) params.append('page', page)
    if (pageSize) params.append('pageSize', pageSize)
    if (fullText) params.append('fullText', fullText)

    const queryString = params.toString()
    return await useBaseAxiosGet({
      url: `/organization-profiles${queryString ? `?${queryString}` : ''}`
    })
  }

  const useFetchOrganizationProfile = async (id) => {
    return await useBaseAxiosGet({
      url: `/organization-profiles/${id}`
    })
  }

  const useCreateOrganizationProfile = async (payload) => {
    return await useBaseAxiosPost({
      url: '/organization-profiles',
      payload: payload
    })
  }

  const useUpdateOrganizationProfile = async (id, payload) => {
    return await useBaseAxiosPut({
      url: `/organization-profiles/${id}`,
      payload: payload
    })
  }

  const useDeleteOrganizationProfile = async (id) => {
    return await useBaseAxiosDelete({
      url: `/organization-profiles/${id}`
    })
  }

  const value = {
    useFetchOrganizationProfiles,
    useFetchOrganizationProfile,
    useCreateOrganizationProfile,
    useUpdateOrganizationProfile,
    useDeleteOrganizationProfile
  }

  return <OrganizationProfilesContext.Provider value={value}>{children}</OrganizationProfilesContext.Provider>
}
